/**
 * Admin guide 1 — the day in one picture: one heartbeat a minute lays out
 * the day once, sends what is due, judges every N minutes, then alerts.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DropGenEngineSettings } from '@trafficpulse/shared';

import { Flow, Points, V } from '../guide-ui';

export const DaySection: FC<{ s: DropGenEngineSettings }> = ({ s }) => (
  <div className="flex flex-col gap-3">
    <Flow
      stamp="One heartbeat a minute, one server at a time"
      steps={[
        { when: 'Once a day · Drop generation', what: 'Lay out the day', how: 'One draft per drop slot, then the AI writes the texts.' },
        { when: 'Every minute', what: 'Send what is due', how: <>Earliest first, at most <V>{s.maxSendsPerMinute}</V> a minute.</> },
        { when: <>Every {s.verdictEveryMin} min</>, what: 'Read stats & judge', how: 'Lists, gateways, hit again, scaling, stop-loss, route-test winner — then it acts.' },
        { when: 'Every minute, last', what: 'Alerts', how: 'The feed and the Slack thread; problems go to the Errors tab.' },
      ]}
    />
    <Points
      items={[
        <>Each tick runs the four steps in this order, on one server only — the others serve the pages.</>,
        <>Stats and verdicts run <V>every {s.verdictEveryMin} min</V> per country. Shorter reacts faster and calls SMSWiser and the trackers more.</>,
        <>Auto-send is <b>Off</b> (nothing goes out), <b>Simulated</b> (decides, sends nothing) or <b>Live</b> (real SMS; the stop-loss has its own on/off switch).</>,
      ]}
    />
  </div>
);
